export default __webpack_public_path__ + "static/FORMES-03-musiques-9e828ffce056fd1760ae0ab00dc8c8e3.svg";